// eslint-disable-next-line no-unused-vars
import * as React from 'react'; 
import { withStyles } from '@material-ui/core/styles';

import i18next from 'i18next';

const styles = () => ({
	root: {
	    color: "white",
	    position: "relative",
	    fontSize: "1em",
	    minWidth: "10em",
	    lineHeight: 1.3,
	    textShadow: "none",
	    fontWeight: "bold",
	    fontFamily: "AIGFutura_Book",
	    borderWidth: "1px 0",
	    borderStyle: "solid",
	    borderColor: "#b3b3b3",
	    backgroundColor: "#00a4e4",
	},
	heading: {
	    flex: "0 1 auto",
	    margin: "0 auto",
	    display: "flex",
	    padding: "0.5em",
	    flexWrap: "wrap",
	    flexGrow: 0,
	    maxWidth: 915,
	    flexBasis: "auto",
	    boxSizing: "border-box",
	    textAlign: "center",
	    flexShrink: 1,
	    alignItems: "center",
	    flexDirection: "row",
	    justifyContent: "center",
	},
	boxTable: {
	    display: "table",
	},
	appLogo: {
	    height: "3em",
	    display: "table-cell",
	    verticalAlign: "middle",
	},
	boxTableCell: {
	    display: "table-cell",
	    fontSize: "2em",
	    paddingLeft: "0.75em",
	    verticalAlign: "middle",
	},
	environment_lbl: {
	    color: "#FFE8C9",
	},
	rightSession: {
	    minWidth: "4em",
	    textAlign: "right",
	    lineHeight: "3em",
	},
	language_lbl: {
	    height: "3em",
	    cursor: "pointer",
	    fontWeight: "normal",
	    verticalAlign: "middle",
	},
	language_seperator: {
		height: "3em",
		fontWeight: "normal",
		verticalAlign: "middle",
	},
});

function updateLanguage(lang) {	
	i18next.changeLanguage(lang);
};

interface PassInProperty{
	classes: any;	
}	

@withStyles(styles)
class PageHeader extends React.Component<PassInProperty> {
	
	render(){
		
		const {classes} = this.props;
		
  		return (
		    <div className={classes.root}>
			    <div className={`row middle-sm ${classes.heading}`}>
			        <div className={`col-xs-8 col-sm-6`}>
			            <div className={`box ${classes.boxTable}`}>
			                <span>
			                    <img className={classes.appLogo}
			                         src="/aigb2c/common/css/aig/aiglogo@2x.png"
			                         alt="AIG" />
		                    </span>
		                    <span className={classes.boxTableCell}>
		                     	&nbsp;
		                 	</span>
		                 	<span className={classes.boxTableCell}>
		                 		<span>
		                 			<span className={classes.environment_lbl}></span>
		             			</span>
		         			</span>
			            </div>
			        </div>
			        <div className={`col-xs-4 col-sm-6`}>
			            <div className={`box ${classes.rightSession}`}>
			                <span className={classes.language_lbl}
			                    onClick={updateLanguage.bind(this, "en")}>EN</span>
		                  	<span className={classes.language_seperator}>&nbsp;|&nbsp;</span>
			                <span className={classes.language_lbl}
			                	onClick={updateLanguage.bind(this, "zh")}>中</span>
			            </div>
			        </div>
			    </div>
		    </div>
	  	);
	}
}

export default PageHeader;